import { TFinalSort } from "components/Table/types";

export const DEFAULT_SORT_CORP_GLOBAL: Record<string, TFinalSort> = {
  name: {
    fieldName: "name",
    key: "name",
    type: "none",
  },
  idUnique: {
    fieldName: "id",
    key: "id",
    type: "none",
  },
  numOfMember: {
    fieldName: "numofmember",
    key: "numOfMember",
    type: "none",
  },
  numOfBusinessEstablishment: {
    fieldName: "bu",
    key: "numOfBusinessEstablishment",
    type: "none",
  },
  numOfOrganization: {
    fieldName: "org",
    key: "numOfOrganization",
    type: "none",
  },
  numOfJob: {
    fieldName: "job",
    key: "numOfJob",
    type: "none",
  },
  description: {
    fieldName: "description",
    key: "description",
    type: "none",
  },
};

export const DEFAULT_FILTER_GLOBAL_CORP = {
  keyword: undefined,
  bu: undefined,
};

export const MAP_SORT = {
  idUnique: "id",
};
